<template>
  <div class="extensions-grid">
    <phone-extension
      v-for="endpoint in identifiedEndpoints"
      :key="endpoint.ref"
      :call="endpoint.onCall"
      :extension="endpoint.ext || endpoint.extension"
      :state="endpoint.state"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import PhoneExtension from "@/components/navbar/PhoneExtension";

export default {
  name: "PhoneExtensions",
  components: {
    PhoneExtension,
  },
  computed: {
    ...mapGetters("pbxCalls", ["endpoints"]),
    identifiedEndpoints() {
      if (!this.endpoints) {
        return [];
      }
      return this.endpoints.reduce((acc, endpoint, idx) => {
        const sameExtCount = acc.filter((e) => e.ext === endpoint.ext).length;
        return [
          ...acc,
          {
            ...endpoint,
            ref: `${endpoint.ext}-${sameExtCount + 1}`,
          },
        ];
      }, []);
    },
  },
};
</script>

<style scoped>
.extensions-grid {
  margin: 0 15px 0 0;
  display: grid;
  width: 150px;
  grid-template-columns: repeat(auto-fill, 30px);
}
</style>
